import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AnalysisHubPage } from './AnalysisHubPage';
import { AnalysisViewerPage } from './AnalysisViewerPage';
import { ClientPortalDashboard } from './ClientPortalDashboard';
import { ClientPortalPlaceholder } from './ClientPortalPlaceholder';
import { FichaPage } from './FichaPage';
import { LineOperationsPage } from './LineOperationsPage';
import { PortalAccessProvider } from './PortalAccessContext';
import { PortalGate } from './PortalGate';
import { SystemMapPage } from './SystemMapPage';

/**
 * Raíz del portal de cliente — se monta en lugar de `<App/>` cuando
 * `main.tsx` detecta un hostname de portal. No importa nada de `App.tsx`;
 * es un árbol de rutas completamente separado, con su propio router,
 * para no arriesgar el enrutamiento general existente.
 */
export function ClientPortalApp({ slug }: { slug: string }): JSX.Element {
  return (
    <PortalAccessProvider slug={slug}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortalGate granted={<ClientPortalDashboard />} />} />
          <Route path="/analysis" element={<PortalGate granted={<AnalysisHubPage />} />} />
          <Route path="/analysis/system-map" element={<PortalGate granted={<SystemMapPage />} />} />
          <Route
            path="/analysis/:analysisId"
            element={<PortalGate granted={<LineOperationsPage />} />}
          />
          {/* Fallback intencionalmente indocumentado — no enlazado desde
              ninguna navegación primaria. Sigue existiendo por si hace
              falta comparar contra el visor legacy completo (con Recorrido/
              Velocidades/Programación/Cobertura originales) mientras se
              termina de validar LineOperationsPage en producción real. */}
          <Route
            path="/analysis/:analysisId/legacy"
            element={<PortalGate granted={<AnalysisViewerPage />} />}
          />
          <Route
            path="/analysis/:analysisId/ficha"
            element={<PortalGate granted={<FichaPage />} />}
          />
          <Route
            path="/documentation"
            element={<PortalGate granted={<ClientPortalPlaceholder title="Documentación" />} />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </PortalAccessProvider>
  );
}
